import React from "react";
import styled from "styled-components";
import { Row, Col, Card, Typography } from "antd";
import { motion } from "framer-motion";
import Hotelservices from "../image/Hotelservices.jpg";
import Imexpservices from "../image/Im-expservices.jpg";
import Realservices from "../image/Realservices.png";
import textileservices from "../image/textileservices.jpg";

const { Title, Paragraph } = Typography;

// Styled Components
const ServicesContainer = styled.div`
  padding: 80px 60px;
  background: linear-gradient(90deg, rgb(3, 13, 51), rgb(0, 53, 55), rgb(0, 0, 0));
  min-height: 100vh;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media (max-width: 768px) {
    padding: 60px 30px;
  }
`;

const SectionTitle = styled(motion(Title))`
  color: white !important;
  font-size: 2.8rem !important;
  font-weight: bold !important;
  margin-bottom: 20px !important;
  text-transform: uppercase;
  margin-top: 50px;
`;

const SectionSubtitle = styled(motion(Paragraph))`
  color: #e0e0e0 !important;
  font-size: 1.3rem !important;
  margin-bottom: 40px !important;
`;

const StyledCard = styled(motion(Card))`
  border-radius: 15px !important;
  text-align: center !important;
  background: rgba(255, 255, 255, 0.1) !important;
  backdrop-filter: blur(10px) !important;
  color: white !important;
  transition: all 0.4s ease-in-out !important;
  border: none !important;
  box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.15) !important;
  overflow: hidden !important;
  position: relative;
  min-height: 600px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;

  &:hover {
    transform: scale(1.08);
    box-shadow: 0px 20px 40px rgba(0, 0, 0, 0.4) !important;
  }

  .ant-card-cover img {
    border-top-left-radius: 15px;
    border-top-right-radius: 15px;
    height: 220px;
    object-fit: cover;
    transition: opacity 0.6s ease-in-out;
  }

  .ant-card-body {
    position: relative;
    z-index: 2;
    padding: 20px !important;
    flex-grow: 1;
  }
`;
// const StyledParagraph = styled(Paragraph)`
//   color: white !important;
//   font-size: 0.95rem !important;
//   line-height: 1.6 !important;
//   text-align: start !important;
//   word-spacing: normal !important;
//   white-space: normal !important;

//   @media (max-width: 768px) {
//     word-spacing: 0.02em;
//   }
// `;

// Framer Motion Animation Variants
const fadeUp = {
  hidden: { opacity: 0, y: 40 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.8, ease: "easeOut" } },
};

const staggerContainer = {
  hidden: { opacity: 0 },
  visible: { opacity: 1, transition: { staggerChildren: 0.3 } },
};

// Service Data
const services = [
  {
    title: "🍽️ Restaurants – Coming Soon",
    slogan: "Good Food. Great Experience",
    description:
      "We are in the process of setting up our first restaurant outlet — a space that blends delicious food with a warm, welcoming atmosphere. Our mission is to create places where people come together to enjoy great meals and lasting memories. Stay tuned for more updates on our grand opening!",
    image: Hotelservices,
  },
  {
    title: "👕 Textile & Garment Trade",
    slogan: "Quality Fabrics for the Modern World",
    description:
      "We are entering the textile industry with a focus on supplying high-quality fabrics and readymade garments for domestic markets. Our network is growing, and we are forming partnerships with trusted manufacturers and buyers to deliver consistent value.",
    image: textileservices,
  },
  {
    title: "🏠 Real Estate Ventures",
    slogan: "Building Dreams from the Ground Up",
    description:
      "We aim to offer smart real estate solutions — from land development to residential and commercial properties. Our focus is on identifying high-growth areas and delivering properties that combine quality construction with smart investment potential.",
    image: Realservices,
  },
  {
    title: "🌐 Import & Export Services",
    slogan: "Connecting Markets Globally",
    description:
      "Our export-import business is being set up to bridge domestic and international markets with Indian goods and vice versa. We plan to work with a wide range of products — from textiles and home goods to industrial materials — backed by reliable logistics and global compliance.",
    image: Imexpservices,
  },
];

const AllServices = () => {
  return (
    <ServicesContainer>
      <SectionTitle initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 1 }}>
        Our Services
      </SectionTitle>

      <SectionSubtitle
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.2, duration: 1 }}
      >
        We offer a range of services across various industries to meet your needs.
      </SectionSubtitle>

      <motion.div variants={staggerContainer} initial="hidden" animate="visible">
        <Row gutter={[32, 32]} justify="center">
          {services.map((service, index) => (
            <Col xs={24} sm={12} md={12} lg={8} xl={6} key={index}>
              <StyledCard
                hoverable
                variants={fadeUp}
                initial="hidden"
                animate="visible"
                whileHover={{ scale: 1.1 }}
                transition={{ delay: index * 0.2 }}
                cover={
                  <motion.img
                    src={service.image}
                    alt={service.title}
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ duration: 1.2 }}
                  />
                }
              >
                <Title
                  level={4}
                  style={{
                    color: "white",
                    marginBottom: "8px",
                    fontWeight: 700,
                  }}
                >
                  {service.title}
                </Title>

                <Paragraph
                  style={{
                    color: "#e0e0e0",
                    fontStyle: "italic",
                    fontSize: "1rem",
                    marginBottom: "14px",
                    lineHeight: 1.4,
                  }}
                >
                  {service.slogan}
                </Paragraph>

                <Paragraph
                  style={{
                    color: "white",
                    fontSize: "0.95rem",
                    lineHeight: "1.6",
                    textAlign: "start",
                    wordSpacing: "normal",
                    whiteSpace: "normal", 
                  }}
                >
                  {service.description}
                </Paragraph>
                {/* <StyledParagraph>{service.description}</StyledParagraph> */}
              </StyledCard>
            </Col>
          ))}
        </Row>
      </motion.div>
    </ServicesContainer>
  );
};

export default AllServices;
